import React from 'react';

import styles from './ActivityLog.module.scss';

const ActivityLog: React.FC = () => {
  // TODO: implement this component. At this time this is a dummy component.
  const items = [
    {
      id: 1,
      text: (
        <span>
          Franz Fischer edited <strong>“Algebra: Polynomials”</strong> grades for{' '}
          <strong>6 students.</strong>
        </span>
      ),
      date: 'May 10, 5:22',
    },
    {
      id: 2,
      text: (
        <span>
          Franz Fischer edited <strong>“Algebra: Polynomials”</strong> grades for{' '}
          <strong>6 students.</strong>
        </span>
      ),
      date: 'May 6, 11:15',
    },
    {
      id: 3,
      text: (
        <span>
          Franz Fischer edited <strong>“Algebra: Polynomials”</strong> grades for{' '}
          <strong>6 students.</strong>
        </span>
      ),
      date: 'Match 2, 13:13',
    },
    {
      id: 4,
      text: (
        <span>
          Franz Fischer edited <strong>“Algebra: Polynomials”</strong> grades for{' '}
          <strong>6 students.</strong>
        </span>
      ),
      date: 'February 26 10, 18:27',
    },
    {
      id: 5,
      text: (
        <span>
          Franz Fischer edited <strong>“Algebra: Polynomials”</strong> grades for{' '}
          <strong>6 students.</strong>
        </span>
      ),
      date: 'February 19, 14:47',
    },
  ];
  return (
    <div className={styles.activityLog}>
      <div className={styles.title}>Activity log</div>
      {items.map(item => (
        <div className={styles.item} key={item.id}>
          <div className={styles.date}>{item.date}</div>
          <div className={styles.text}>{item.text}</div>
        </div>
      ))}
    </div>
  );
};

export default ActivityLog;
